import { useQuery } from 'react-query';

import { getDHTClaSettingsById } from 'RestAPIs/admin';

const useGetDHTClaById = (id?: number) => {
  const { data, isFetching } = useQuery(
    ['DHTClaSettings', 'get'],
    async () => {
      const { data } = await getDHTClaSettingsById(id);
      return data;
    },
    { enabled: !!id }
  );

  return { data, isFetching };
};

export default useGetDHTClaById;
